"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStar = getStar;
var localization = require("./localization");
function getStar(stars, translationLocale) {
    var stringKey = (stars == 0) ? '4' : stars.toString();
    var locale = localization.parseLocale(translationLocale);
    return {
        locale: locale,
        string: localization.get(locale, 'star-ratings', stringKey),
        stars: stars,
    };
}
